/**
 * A Phoenix LiveView hook that detects clicks outside of an element.
 *
 * This hook is useful for implementing dismissible dropdowns, modals, or any UI element
 * that should close when clicking outside of it. It pushes a "click_outside" event
 * to the LiveView when a click occurs anywhere outside the element.
 *
 * @example
 * ```html
 * <div
 *   id="my-dropdown"
 *   phx-hook="ClickOutside"
 *   class="dropdown-menu"
 * >
 *   <!-- Dropdown content -->
 * </div>
 * ```
 *
 * Then in your LiveView:
 * ```elixir
 * def handle_event("click_outside", _params, socket) do
 *   # Close dropdown, modal etc.
 *   {:noreply, assign(socket, show_dropdown: false)}
 * end
 * ```
 */
const ClickOutside = {
  mounted() {
    this.handleClick = (e) => {
      if (!this.el.contains(e.target)) {
        this.pushEventTo(this.el, "click_outside", {})
      }
    }
    document.addEventListener("click", this.handleClick)
  },

  destroyed() {
    document.removeEventListener("click", this.handleClick)
  }
}

export default ClickOutside 